import { useFormatter } from '@capsicum/common';
import { Text } from '@capsicum/common-web';
import { type FanTokenBreakdownCardTokenProps } from '@capsicum/features/nc-wallet/shared';
import { useId } from 'react';
import styled from 'styled-components';

import { V2MigrationFanTokenLogo } from '../v2ft-migration/V2MigrationFanTokenLogo';

export const FanTokenBreakdownCardToken = ({ amount, logo, name, shortCode }: FanTokenBreakdownCardTokenProps) => {
	const sectionID = useId();
	const { formatCrypto } = useFormatter();

	return (
		<S.Wrapper>
			<S.Team>
				<V2MigrationFanTokenLogo logo={logo} name={name} shortCode={shortCode} size={16} />

				<Text color="main.unselected" id={sectionID} variant="text4">
					{name}
				</Text>
			</S.Team>

			<S.MonetaryAmount aria-labelledby={sectionID} color="main.unselected" variant="text4">
				{formatCrypto(amount, shortCode)}
			</S.MonetaryAmount>
		</S.Wrapper>
	);
};

namespace S {
	export const Wrapper = styled.div`
		display: flex;
		align-items: center;
		justify-content: space-between;
	`;

	export const Team = styled.div`
		display: flex;
		align-items: center;
		gap: ${({ theme }) => theme.spacings.xxxsmall};
	`;

	export const MonetaryAmount = styled(Text)`
		text-align: right;
	`;
}
